export const NAME = 'TransportGrants';

export const REQUEST_TRANSPORT_GRANTS = `${NAME}/REQUEST_TRANSPORT_GRANTS`;
export const REQUEST_TRANSPORT_GRANTS_SUCCESS = `${NAME}/REQUEST_TRANSPORT_GRANTS_SUCCESS`;
export const REQUEST_TRANSPORT_GRANTS_FAILURE = `${NAME}/REQUEST_TRANSPORT_GRANTS_FAILURE`;

export const EMPLOYEE_TRANSPORT_GRANT_REGISTER = `${NAME}/EMPLOYEE_TRANSPORT_GRANT_REGISTER`;
export const EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS = `${NAME}/EMPLOYEE_TRANSPORT_GRANT_REGISTER_SUCCESS`;
export const EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE = `${NAME}/EMPLOYEE_TRANSPORT_GRANT_REGISTER_FAILURE`;

export const STATE_PROPS = {
  PublicTransportation: 'PublicTransportation',
  Cycling: 'Cycling',
  Walking: 'Walking',
  TransportationCard: 'TransportationCard',
};

export const ICONS = {
  [STATE_PROPS.PublicTransportation]: 'directions_transit',
  [STATE_PROPS.Cycling]: 'directions_bike',
  [STATE_PROPS.Walking]: 'directions_walk',
  [STATE_PROPS.TransportationCard]: 'directions_bus',
};



// WEBPACK FOOTER //
// ./src/sites/transportationGrants/constants.js